import { SAMPLE_EXPENSES_BY_ACCOUNT } from './sampleExpenses';
import type { AccountExpense } from './types';

const NO_EXPENSES: ReadonlyArray<AccountExpense> = [];

// Same shape as the other Account list hooks, so wiring svc-contracting only replaces this body.
export function useAccountExpenses(accountId: string): {
  error: Error | null;
  expenses: ReadonlyArray<AccountExpense>;
  isLoading: boolean;
} {
  return { error: null, expenses: SAMPLE_EXPENSES_BY_ACCOUNT[accountId] ?? NO_EXPENSES, isLoading: false };
}
